import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../vue";
import commonStyles from "../../../style/class.module.css";
let LabelSwitch = class LabelSwitch extends Vue {
  onChange() {
    this.$emit('input', !this.value);
  }
  onDdClick(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": commonStyles.label
    }, [this.title, this.forceShow ? null : // <a-icon style="margin-left:8px" type={'eye'} />
    h("a-tooltip", {
      "attrs": {
        "title": this.value ? '隐藏配置' : '显示配置'
      }
    }, [h("a-icon", {
      "style": "margin-left:8px",
      "attrs": {
        "type": this.value ? 'eye' : 'eye-invisible',
        "wj-eid": this.title
      },
      "on": {
        "click": this.onChange
      },
      "nativeOn": {
        "dblclick": this.onDdClick
      }
    })])]);
  }
};
__decorate([Prop()], LabelSwitch.prototype, "title", void 0);
__decorate([Prop()], LabelSwitch.prototype, "value", void 0);
__decorate([Prop({
  default: false
})], LabelSwitch.prototype, "forceShow", void 0);
LabelSwitch = __decorate([Component({
  name: 'LabelSwitch'
})], LabelSwitch);
export default LabelSwitch;
//# sourceMappingURL=LabelSwitch.js.map
